import { $api } from '@service/RequestService';
import { useInfiniteQuery } from 'react-query';

export function useCompanySelect() {
  const { data, ...arg } = useInfiniteQuery<
    {
      totalPages: number;
      currentPage: number;
      totalElements: number;
      companies: { id: number; name: string }[];
    },
    { id: number; name: string }
  >(
    ['realtor-company-select'],
    async ({ pageParam = 1 }) => {
      const { data } = await $api.post('/v1/company/for-select', {
        page: pageParam,
        size: 50
      });

      return { ...data?.data, companies: data?.data?.data };
    },
    {
      retry: false,
      getNextPageParam: (lastPage, page) => {
        if (page.length < lastPage?.totalPages) {
          return page.length + 1;
        }

        return undefined;
      }
    }
  );

  return {
    totalPages: data?.pages?.[0]?.totalPages || 0,
    currentPage: data?.pages?.[(data?.pages?.length || 1) - 1]?.currentPage || 1,
    companies: data?.pages
      .flat()
      ?.map(({ companies }) => companies)
      ?.flat(),
    ...arg
  };
}
